import { render, staticRenderFns } from "./Page.component.vue?vue&type=template&id=f39bbcb6&scoped=true&"
import script from "./Page.component.vue?vue&type=script&lang=ts&"
export * from "./Page.component.vue?vue&type=script&lang=ts&"
import style0 from "./Page.component.vue?vue&type=style&index=0&id=f39bbcb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39bbcb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
